import { selectSelectedRowIds } from '../createEagGridStore';
import { useEagGridSelector } from '../useEagGridSelector';
export function useSelectedRowIds() {
  return useEagGridSelector(selectSelectedRowIds);
}